export const MISC = {
    COGNITO: {
        USER: 'cognito__user',
    },
    MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};

